<template>
  <v-dialog
    :value="dialogs.manageTwoFactorAuthDialog"
    fullscreen
    :transition="false"
    @click:outside="handleDialogClose"
    @keydown.esc="handleDialogClose"
  >
    <v-card style="border-radius: 0;">
      <v-card-text>
        <div class="two-factor-dialog-wrapper">
          <div class="two-factor-dialog">
            <v-container style="max-width: 1264px">
              <v-btn
                text
                color="primary"
                @click="handleDialogClose"
              >
                <v-icon
                  :size="16"
                  class="mr-1"
                >
                  mdi-arrow-left
                </v-icon>
                {{ $t('common.back') }}
              </v-btn>
              <div class="dialog-title">
                {{ $t('twoFactor.titleSettings') }}
              </div>
              <v-row class="dialog-cards-wrapper">
                <v-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <v-card class="dialog-card" elevation="0">
                    <div class="card-title">
                      {{ $t('twoFactor.yourBackupCodes') }}
                    </div>

                    <div class="description-text your-backup-codes-desc flex-grow-1">
                      {{ $t('twoFactor.yourBackupCodesDesc') }}
                    </div>

                    <v-btn
                      color="primary"
                      class="btn"
                      width="100%"
                      height="44px"
                      outlined
                      rounded
                      :loading="loading"
                      style="margin-top: 48px"
                      @click="handleViewBackupCodesClick"
                    >
                      {{ $t('twoFactor.viewBackupCodes') }}
                    </v-btn>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <v-card class="dialog-card" elevation="0">
                    <div class="card-title flex-grow-1">
                      {{ $t('twoFactor.settings') }}
                    </div>
                    <div>
                      <v-btn
                        color="primary"
                        class="btn"
                        width="100%"
                        height="44px"
                        outlined
                        rounded
                        style="margin-top: 24px"
                        @click="handleChangeDeviceClick"
                      >
                        {{ $t('twoFactor.changeDevice') }}
                      </v-btn>

                      <v-btn
                        color="primary"
                        class="btn turn-off-btn"
                        width="100%"
                        height="44px"
                        outlined
                        rounded
                        @click="handleTurnOffDeviceClick"
                      >
                        {{ $t('twoFactor.turnOff') }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <dialog-two-factor-auth-backup-codes v-if="dialogs.twoFactorAuthBackupCodesDialog" />
    <dialog-two-factor-auth-confirm
      v-if="dialogs.confirmTwoFactorAuthDialog"
      :on-code-confirm="successFunction"
      :turn-off="turnOffSelected"
    />
  </v-dialog>
</template>

<script>
  import DialogTwoFactorAuthBackupCodes from "./DialogTwoFactorAuthBackupCodes";
  import { mapGetters } from "vuex";
  import DialogTwoFactorAuthConfirm from "./DialogTwoFactorAuthConfirm";

  export default {
    name: 'DialogTwoFactorAuthManage',

    components: {
      DialogTwoFactorAuthConfirm,
      DialogTwoFactorAuthBackupCodes
    },

    data () {
      return {
        loading: false,
        successFunction: null,
        turnOffSelected: false
      }
    },

    computed: {
      ...mapGetters({
        dialogs: 'main/dialogs',
      }),
    },

    methods: {
      handleDialogClose () {
        this.$store.dispatch('main/closeDialog', 'manageTwoFactorAuthDialog')
        this.$store.dispatch('main/closeDialog', 'twoFactorAuthBackupCodesDialog')
        this.$store.dispatch('main/closeDialog', 'confirmTwoFactorAuthDialog')
      },

      async handleViewBackupCodesClick () {
        this.loading = true

        try {
          const showCodesResponse = await this.api.get('two-factory/show-codes')

          if (showCodesResponse.status === 200) {
            this.$store.dispatch('main/setTwoFactorBackupCodes', showCodesResponse.data)
            this.$store.dispatch('main/openDialog', 'twoFactorAuthBackupCodesDialog')
          }
        } catch (error) {
          console.log(`Error on viewing backup codes - ${error}`)
        } finally {
          this.loading = false
        }
      },

      handleChangeDeviceClick () {
        this.$store.dispatch('main/openDialog', 'confirmTwoFactorAuthDialog')
        this.$store.dispatch('main/setTwoFactorChangeDevice', true)

        this.successFunction = this.onChangeDeviceSuccessfulCodeConfirm
      },

      handleTurnOffDeviceClick () {
        this.turnOffSelected = true

        this.$store.dispatch('main/openDialog', 'confirmTwoFactorAuthDialog')

        this.successFunction = this.onTurnOffSuccessfulCodeConfirm
      },

      onChangeDeviceSuccessfulCodeConfirm () {
        this.$store.dispatch('main/closeDialog', 'manageTwoFactorAuthDialog')
        this.$store.dispatch('main/openDialog', {
          name: 'enableTwoFactorAuthDialog',
          props: {
            twoFactorChangeDevice: true
          }
        })
      },

      onTurnOffSuccessfulCodeConfirm () {
        this.handleDialogClose()
      }
    }
  }
</script>

<style scoped>
  .card-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.15px;
    color: rgba(0, 0, 0, 0.87);
  }

  .your-backup-codes-desc {
    margin-top: 16px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.5px;
    color: rgba(0, 0, 0, 0.7);
  }

  .dialog-card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .btn {
    text-transform: unset;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #B645EE;
  }

  .turn-off-btn {
    margin-top: 16px;
  }
</style>
